import { render, staticRenderFns } from "./RecruitTagEditLayer.vue?vue&type=template&id=61dbceb2&scoped=true&"
import script from "./RecruitTagEditLayer.vue?vue&type=script&lang=js&"
export * from "./RecruitTagEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./RecruitTagEditLayer.vue?vue&type=style&index=0&id=61dbceb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dbceb2",
  null
  
)

export default component.exports